<div class="container g-0" *ngIf="filters.length > 0">
  <div class="d-flex align-items-baseline">
    <ng-container *ngFor="let facet of filters">
      <div class="search-filter-box-container">
        <span class="search-filter-box-text">{{facet.displayString}}</span>
        <span class="search-filter-box-svg" (click)="deleteFilterItem(facet)">
            <a>
               <svg-icon key="close" width="12px" height="12px"></svg-icon>
            </a>
         </span>
      </div>
    </ng-container>
    <div class="search-filter-box-clear-all-container align-self-end" *ngIf="clearFilters">
         <span class="search-filter-box-clear-all-text" (click)="deleteFilterItem(clearFilters)">
         	<a>{{clearFilters.displayString}}</a>
         </span>
    </div>
  </div>
</div>
